import Styles from './CaptionTab.module.scss'
import { Drawer } from 'components/Drawer'
import { CaptionTab } from './CaptionTab'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useRootStore } from 'stores/RootStore'

export const CaptionDrawer = observer((props: DrawerProps) => {
  const { designStore } = useRootStore()
  const captionsStore = designStore?.captionsStore

  return (
    <Drawer.Root activeSnapPoint={1} snapPoints={[1]} {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop className={Styles.drawer}>
            <Drawer.Top>
              <Drawer.Close label="Close" />
              <Drawer.Title asChild>
                <Heading level={5}>{captionsStore?.sectionTitle ?? 'Caption'}</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container className={Styles.drawerContainer}>
              <CaptionTab />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
